import {
    Sky,
    Environment,
    Center,
    OrbitControls,
    PresentationControls,
    KeyboardControls} from '@react-three/drei'
import {
    EffectComposer,
    N8AO,
    Vignette,
    Autofocus,
  } from "@react-three/postprocessing";
import { Physics } from '@react-three/rapier'
import { useRef, useState } from 'react'
import Boat from './components/Boat'
import { Water } from './water'
import {Island} from './components/Island'
import { Canvas, useFrame } from '@react-three/fiber'
import { useControls } from 'leva'
import { useThree } from '@react-three/fiber'



function Foo() {
  const camera = useThree(state => state.camera)
  useFrame((state, delta) => {
    console.log(camera.position)
  }
  )
}

export default function Experience() {

    const { blur, AO, PostProcessing } = useControls({
        PostProcessing: {
          value: true,
        },
        blur: {
          value: true,
        },
        AO: {
          value: false,
        },
      });

    return <>
        <KeyboardControls
        map={[
            { name: "forward", keys: ["ArrowUp", "w", "W"] },
            { name: "backward", keys: ["ArrowDown", "s", "S"] },
            { name: "leftward", keys: ["ArrowLeft", "a", "A"] },
            { name: "rightward", keys: ["ArrowRight", "d", "D"] },
            { name: "jump", keys: ["Space"] },
        ]}>
        <Canvas
                camera={ {
                    fov: 45,
                    near: 0.1,
                    far: 500,
                    position: [30, 9.5, -17.5],
                } }
            >
                <Foo />
            <OrbitControls makeDefault />
            
            {/* <ambientLight intensity={0.5} /> */}
            {/* <PresentationControls 
                snap global zoom={0.8} 
                rotation={[0, -Math.PI / 4, 0]} 
                polar={[0, Math.PI / 4]} 
                azimuth={[-Math.PI / 4, Math.PI / 4]}
            /> */}
            <Environment preset="sunset" />
            <Physics gravity={ [ 0, 0, 0 ] }>
            <Center>
                <Water 
                    position={[0, 0, 0]}
                />
                <Island 
                    position={[0, 0, 0]}
                />
                <Boat 
                   position={[15, 2, -10]}
                />
                <Sky distance={450000} sunPosition={[0, 1, 0]} inclination={0} azimuth={0.25} />
            </Center>
            </Physics>

        {PostProcessing && (
          <EffectComposer>
            <Vignette offset={0.4} darkness={0.4} />
            {AO && <N8AO aoRadius={20} intensity={8} screenSpaceRadius />}
            {blur && <Autofocus bokehScale={4} focusRange={0.01} />}
          </EffectComposer>
        )}
        </Canvas>
        </KeyboardControls>
    </>
}